import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Card, Spin, Alert, Divider } from "antd";
import moment from "moment";
import reportSvc from "../services/reportSvc";
import LaporanInformationCard from "../components/LaporanInformationCard";
import ReportPage from "./ReportDailyNonAuth";

moment.tz.setDefault("Asia/Bangkok");

export default function ReportDailyWithSidebar() {
  const { cabang } = useParams();

  // build the src pointing at your React Router-served page
  //   const src = `${window.location.origin}/report/daily?cabang=${cabang}`;

  return (
    <div>
      <ReportPage cabang={cabang} />
    </div>
  );
}
